import axios from "axios";
import { UserMe } from "./authTypes";

export const fetchAuthentication = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  return axios
    .post(`${process.env.REACT_APP_AUTH_PATH}/auth/signin`, {
      email,
      password,
    })
    .then(({ data }) => {
      return data.token;
    });
};

export const fetchUserMeData = async (token: string) => {
  return axios
    .get<UserMe>(`${process.env.REACT_APP_API_PATH}/users/profile/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(({ data }) => {
      return data;
    });
};

export const fetchBlockData = async (token: string, buildingId: string) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_PATH}/building-structure/${buildingId}/filter`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(({ data }) => {
      return data;
    });
};
